import { withInstall, SFCWithInstall } from '@touchvue/utils'
import DatePicker from './src/DatePicker.vue'

export const ToDatePicker: SFCWithInstall<typeof DatePicker> = withInstall(DatePicker)
export * from './src/DatePicker.vue'

export * from './src/use-date-picker'
